module.exports = __webpack_public_path__ + "img/empty-data.6edbaa78.svg";